import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { useAccessToken } from "../../../common/hooks/useAccessToken";
import { fetchBuildingData } from "../../../store/buildings/actions";
import { showLoader, hideLoader } from "../../../store/common/slice";
import { isAdminSelector } from "../../../store/auth/selectors";
import NewAddress from "../NewAddress";
import { EditBuildingPage } from "./EditBuilding.styled";

const EditBuilding = ({ match }) => {
    const { t } = useTranslation();
    const { buildingID } = match.params;
    const client = useAccessToken();
    const dispatch = useDispatch();
    const isAdmin = useSelector(isAdminSelector);

    const [addressData, setAddressData] = useState({});
    const [buildingAddress, setBuildingAddress] = useState([]);
    const [entrance, setEntrance] = useState('');

    useEffect(() => {
        (async function () {
            if (!client) return;
            dispatch(showLoader());

            const { payload: { address } } = await dispatch(fetchBuildingData({buildingID}));
            setAddressData({
                latitude: address?.latitude,
                longitude: address?.latitude
            });
            setBuildingAddress([
                address?.country && {
                    long_name: address.country,
                    types: ['country']
                },
                address?.city && {
                    long_name: address.city,
                    types: ['locality']
                },
                address?.street && {
                    long_name: address.street,
                    types: ['route']
                },
                address?.streetNumber && {
                    long_name: address.streetNumber,
                    types: ['street_number']
                },
                address?.nickname && {
                    long_name: address.nickname,
                    types: ['nickname']
                },
            ]);
            if (address?.entrance) setEntrance(address.entrance);
            dispatch(hideLoader());
        })();
    }, [client]);

    if (!isAdmin) return <div>{t('searchPayments.noAdminRights')}</div>;

    return (
        <EditBuildingPage>
            <h1 className='page-title'>
                {t('buildings.editBuildingTitle')}
            </h1>
            <div className="container">
                <div className="col-md-12">
                        <NewAddress
                            address={buildingAddress}
                            entranceNumber={entrance}
                            addressData={addressData}
                            buildingID={buildingID}
                        />

                </div>
            </div>
        </EditBuildingPage>
    );
};

export default EditBuilding;
